export default __webpack_public_path__ + "static/media/elasticsearch.765bccc5.svg";